import React from 'react';
import { ProgressBar } from '../shared/ProgressBar';
interface GoalTrackerProps {
  completed: number;
  total: number;
}
export const GoalTracker = ({
  completed,
  total
}: GoalTrackerProps) => {
  const progress = Math.round(completed / total * 100);
  return <div className="bg-blue-50 rounded-xl p-4" data-id="element-882">
      <div className="flex justify-between items-center mb-2" data-id="element-883">
        <h3 className="font-medium text-blue-800" data-id="element-884">Your Progress</h3>
        <span className="text-sm text-blue-600" data-id="element-885">
          {completed} of {total} workouts
        </span>
      </div>
      <ProgressBar progress={progress} color="bg-blue-500" height={8} data-id="element-886" />
      <div className="mt-3 flex items-start" data-id="element-887">
        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 text-blue-500 flex-shrink-0" data-id="element-888">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-889">
            <circle cx="12" cy="12" r="10" data-id="element-890"></circle>
            <line x1="12" x2="12" y1="8" y2="12" data-id="element-891"></line>
            <line x1="12" x2="12.01" y1="16" y2="16" data-id="element-892"></line>
          </svg>
        </div>
        <p className="text-xs text-blue-700" data-id="element-893">
          Need to adjust your plan? Tap "Skip" on any workout and we'll
          automatically reschedule to keep you on track.
        </p>
      </div>
    </div>;
};